import { useQuery } from "@tanstack/react-query";
import type { VehicleVariant } from "@spare-cart/contracts/vehicles";
import { apiClient, toQueryRecord } from "@core/api";

export const useVehicleVariantsByModel = (modelId: string | undefined) =>
  useQuery({
    queryKey: ["shared", "vehicle-variants", modelId],
    queryFn: () =>
      apiClient.list<VehicleVariant>("/vehicle-variants", {
        query: toQueryRecord({ page: 1, limit: 50, modelId, isActive: "true" }),
      }),
    enabled: modelId !== undefined,
  });
